module.exports = __webpack_public_path__ + "1f9c219957b401539d6771ccd1867e89.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/shared-inner-menu/shared-inner-menu.html
// module id = 1874
// module chunks = 0